var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 5C16.1998 5 4.99976 16.2 4.99976 30C4.99976 43.8 16.1998 55 29.9998 55C43.7998 55 54.9998 43.8 54.9998 30C54.9998 16.2 43.7998 5 29.9998 5ZM29.0248 37.1C29.0248 39.825 26.8998 41.95 24.1748 41.95H20.4748C17.7998 41.95 15.6248 39.775 15.6248 37.1V30.425C15.6248 22.725 17.2998 21 21.7748 18.35C22.0748 18.175 22.3998 18.1 22.7248 18.1C23.3748 18.1 23.9998 18.425 24.3498 19.025C24.8748 19.925 24.5748 21.075 23.6998 21.6C20.6748 23.35 19.6248 24 19.4248 28.525H24.1998C26.9248 28.525 29.0498 30.65 29.0498 33.375V37.1H29.0248ZM44.3748 37.1C44.3748 39.825 42.2498 41.95 39.5248 41.95H35.7998C33.1248 41.95 30.9498 39.775 30.9498 37.1V30.425C30.9498 22.725 32.6248 21 37.0998 18.35C37.3998 18.175 37.7248 18.1 38.0498 18.1C38.6998 18.1 39.3248 18.425 39.6748 19.025C40.1998 19.925 39.8998 21.075 39.0248 21.6C35.9998 23.4 34.9498 24.05 34.7498 28.575H39.5248C42.2498 28.575 44.3748 30.7 44.3748 33.425V37.1V37.1Z",
    fill: "#EE335E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteCircleIcon);
export default __webpack_public_path__ + "static/media/quote-circle-icon.83bbca5a8bc7647ec038ea7e71e39bf3.svg";
export { ForwardRef as ReactComponent };